module.exports = __webpack_public_path__ + "static/media/bg.4f9f4ee2.png";